<template>
    <v-container>
        <!-- Text Fields -->
        <v-card class="mb-4">
            <v-card-text>
                <v-text-field v-model="template.appCode" :label="$t('AppCode')" readonly></v-text-field>
                <v-text-field v-model="template.name" :label="$t('Name')" readonly></v-text-field>
                <v-text-field v-model="template.subject" :label="$t('Subject')"></v-text-field>
            </v-card-text>
        </v-card>

        <!-- Unlayer Editor -->
        <v-card>
            <v-card-text>
                <!--<div id="editor" style="height: 550px"></div>-->
                <div id="gjs"></div>
            </v-card-text>

            <v-card-actions>
                <!-- Share Button -->
                <v-spacer />
                <v-btn color="primary" @click="saveTemplate" class="mt-2">{{$t('Save')}}</v-btn>
                <v-btn link to="/email-templates" color="error" class="mt-2 mx-2">{{$t('Cancel')}}</v-btn>
                <v-spacer />
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { ref, onMounted } from 'vue'
    import grapesjs from 'grapesjs'
    import 'grapesjs/dist/css/grapes.min.css'
    import plugin from 'grapesjs-preset-newsletter'
    import EmailTemplatesService from '@/services/EmailTemplatesService.js'
    import juice from 'juice'
    export default {
        data() {
            return {
                emailInput: '',
                editor:null,
                htmlContent: '',
                templateObj: {},
                designJson: {},
                template: {
                    appCode: '',
                    name: '',
                    subject: ''
                }
            }
        },
        computed: {
            ...mapGetters('user', ['language']),
            getLanguage() {
                return this.language == null ? 'ar' : this.language
            },
        },
        methods: {
            async saveTemplate() {
                try {
                    const html = this.editor.getHtml()

                    // Get the CSS styles
                    const css = this.editor.getCss()

                    // Combine HTML and CSS into one string if needed
                    const fullHtml = `
  <html>
    <head>
      <style>${css}</style>
    </head>
    <body>
      ${html}
    </body>
  </html>
`
                    this.htmlContent = juice(fullHtml)
                    this.template.body = this.htmlContent
                    var response = await EmailTemplatesService.updateTemplate(this.$route.query.id, this.template)
                    if (response.success) {
                        this.$root.$notification(this.$t('UpdateSuccess'), 'success')
                        this.$router.push('/email-templates')
                    } else {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }
                } catch (error) {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }
            },
            async initUnlayer() {
                /*unlayer.init({
                    id: 'editor',
                    displayMode: 'email',
                    locale: this.language == null ? 'ar' : this.language
                    // Add any additional configuration options here
                })*/
                this.templateObj = await EmailTemplatesService.getTemplateById(this.$route.query.id)
                this.template = this.templateObj.data
                this.htmlContent = this.templateObj.data.body
                this.editor = grapesjs.init({
                    container: '#gjs',
                    plugins: [plugin],
                    pluginsOpts: {
                        [plugin]: { /* options */ }
                    },
                    storageManager: false,

                }),

                    this.editor.setComponents(this.htmlContent)
                /*if (this.templateObj.data.designJson) {
                    unlayer.loadDesign(JSON.parse(this.templateObj.data.designJson))
                } else {
                    unlayer.loadDesign({
                        body: {
                            rows: [
                                {
                                    cells: [1],
                                    columns: [
                                        {
                                            contents: [
                                                {
                                                    type: 'html',
                                                    values: {
                                                        html: this.htmlContent,
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    })
                }
                unlayer.addEventListener('design:updated', () => {

                    unlayer.exportHtml((data) => {
                        this.htmlContent = data.html
                        this.designJson = data.design
                        this.template.body = this.htmlContent
                        this.template.designJson = JSON.stringify(this.designJson)
                    })
                })*/
            },
        },
        mounted() {
            this.initUnlayer()
        },
    }
</script>

<style>
    /* Add any custom styles here */
</style>
